export class resetBO {
    email: string = "";
    agencycode: string = "";
}